export default "__VITE_ASSET__DHIPHu56__"